(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jouri-popular-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jouri-product-carousel')) {
    customElements.define('jouri-product-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.j-popular__grid');
        this.cards = [...this.track.children];
        this.controls = this.querySelector('[data-carousel-controls]');
        this.previous = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const sync = () => this.sync();
        let frame;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
          this.frame = frame;
        }, { passive: true, signal });
        this.track.addEventListener('scrollend', sync, { signal });
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !this.mobile.matches) return;
          const direction = this.rtl ? -1 : 1;
          const changes = { ArrowRight: direction, ArrowLeft: -direction, Home: -this.cards.length, End: this.cards.length };
          if (!(event.key in changes)) return;
          event.preventDefault();
          this.move(changes[event.key]);
        }, { signal });
        this.mobile.addEventListener('change', sync, { signal });
        this.observer = new ResizeObserver(sync);
        this.observer.observe(this.track);
        this.sync();
      }
      positions() {
        const bounds = this.track.getBoundingClientRect();
        const style = getComputedStyle(this.track);
        this.rtl = style.direction === 'rtl';
        const padding = parseFloat(style.scrollPaddingInlineStart) || 0;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        return this.cards.map(card => {
          const rect = card.getBoundingClientRect();
          const offset = this.rtl ? rect.right - bounds.right + padding : rect.left - bounds.left - padding;
          const target = this.track.scrollLeft + offset;
          return this.rtl ? Math.max(-maximum, Math.min(0, target)) : Math.max(0, Math.min(maximum, target));
        });
      }
      sync() {
        if (!this.track.clientWidth) return;
        this.controls.hidden = !this.mobile.matches || this.cards.length < 2 || this.track.scrollWidth <= this.track.clientWidth + 1;
        this.track.tabIndex = this.mobile.matches ? 0 : -1;
        const positions = this.positions();
        this.current = positions.reduce((nearest, value, index) => Math.abs(value - this.track.scrollLeft) < Math.abs(positions[nearest] - this.track.scrollLeft) ? index : nearest, 0);
        const current = this.current + 1;
        const total = this.cards.length;
        const counter = this.querySelector('[data-carousel-count]');
        const announcement = this.querySelector('[data-carousel-announcement]');
        const position = `${String(current).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;
        const message = this.dataset.positionLabel.replace('[current]', current).replace('[total]', total);
        if (counter.textContent !== position) counter.textContent = position;
        if (announcement.textContent !== message) announcement.textContent = message;
        this.querySelector('[data-carousel-progress]').style.setProperty('--j-carousel-progress', current / total);
        this.previous.setAttribute('aria-disabled', String(this.current === 0));
        this.next.setAttribute('aria-disabled', String(this.current === total - 1));
      }
      move(change) {
        if (!this.mobile.matches) return;
        const index = Math.max(0, Math.min(this.cards.length - 1, (this.current || 0) + change));
        this.track.scrollTo({ left: this.positions()[index], behavior: this.reduced.matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
